import React from 'react';

import { GraphRef, graphRefToString } from 'src/app/graph/hooks/useGraphRef';
import { getAmplitudeApplicationMode } from 'src/lib/analytics/amplitude/helpers/getAmplitudeApplicationMode';
import { ampli } from 'src/lib/analytics/amplitude/vendor';

export const useTrackL1PageView = (
  pageName:
    | 'changeLogL1'
    | 'checksL1'
    | 'clientsL1'
    | 'cloudRouterL1'
    | 'explorer'
    | 'graphSettingsL1'
    | 'launchesL1'
    | 'operationsL1'
    | 'schemaL1'
    | 'settingsL1'
    | 'subgraphsL1'
    | 'variantsHomeL1',
  { graphRef }: { graphRef: GraphRef | null },
) => {
  React.useEffect(() => {
    ampli[`${pageName}Viewed`]({
      'Application Mode': getAmplitudeApplicationMode(),
      graphRef: graphRefToString(graphRef) ?? 'unknown',
    });
  }, [pageName, graphRef]);
};
